export const SearchResultContainer = (props) => {
    return (
        <div className="search-result my-8">
          {props.children}
        </div>
    );
}